import React from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAddToExisting: () => void;
  onCreateNew: () => void;
}

const CarePlanModeModal: React.FC<Props> = ({ 
  isOpen, 
  onClose, 
  onAddToExisting, 
  onCreateNew 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Care Plan Mode</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            ×
          </button>
        </div>
        
        <p className="text-gray-600 mb-6">
          Would you like to add this Care Plan to an existing submission or create a new one?
        </p>
        
        <div className="flex flex-col gap-3">
          <button
            onClick={onAddToExisting}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded hover:bg-blue-700 transition-colors"
          >
            Add to Existing Submission
          </button>
          
          <button
            onClick={onCreateNew}
            className="w-full bg-gray-300 text-gray-700 py-3 px-4 rounded hover:bg-gray-400 transition-colors"
          >
            Create New Submission
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarePlanModeModal;